import type { CustomCssVariables } from '@thoughtspot/visual-embed-sdk';

export const allSDKEnabledVars: CustomCssVariables = {
  '--ts-var-root-color': 'initial',
  '--ts-var-root-background': 'initial',
  '--ts-var-root-font-family': 'initial',
  '--ts-var-root-text-transform': 'initial',
  '--ts-var-application-color': 'initial',
  '--ts-var-nav-color': 'var(--ts-var-root-color)',
  '--ts-var-nav-background': 'initial',
  '--ts-var-search-data-button-font-color': 'var(--ts-var-root-color)',
  '--ts-var-search-data-button-background': 'initial',
  '--ts-var-search-data-button-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-search-bar-text-font-color': 'var(--ts-var-root-color)',
  '--ts-var-search-bar-text-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-search-bar-text-font-style': 'initial',
  '--ts-var-search-bar-background': 'initial',
  '--ts-var-search-auto-complete-background': 'initial',
  '--ts-var-search-auto-complete-font-color': 'var(--ts-var-root-color)',
  '--ts-var-search-auto-complete-subtext-font-color': 'initial',
  '--ts-var-search-navigation-button-background': 'initial',
  '--ts-var-search-bar-navigation-help-text-background': 'initial',
  '--ts-var-search-bar-auto-complete-hover-background': 'initial',
  '--ts-var-spotter-input-background': 'initial',
  '--ts-var-spotter-prompt-background': 'initial',
  '--ts-var-answer-data-panel-background-color': 'initial',
  '--ts-var-answer-view-table-chart-switcher-background': 'initial',
  '--ts-var-answer-view-table-chart-switcher-active-background': 'initial',
  '--ts-var-answer-edit-panel-background-color': 'initial',
  '--ts-var-button-border-radius': 'initial',
  '--ts-var-button--icon-border-radius': 'initial',
  '--ts-var-button--primary-color': 'var(--ts-var-root-color)',
  '--ts-var-button--primary-background': 'initial',
  '--ts-var-button--primary--hover-background': 'initial',
  '--ts-var-button--primary--font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-button--primary--active-background': 'initial',
  '--ts-var-button--secondary-color': 'var(--ts-var-root-color)',
  '--ts-var-button--secondary-background': 'initial',
  '--ts-var-button--secondary--hover-background': 'initial',
  '--ts-var-button--secondary--font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-button--secondary--active-background': 'initial',
  '--ts-var-button--tertiary-color': 'var(--ts-var-root-color)',
  '--ts-var-button--tertiary-background': 'initial',
  '--ts-var-button--tertiary--hover-background': 'initial',
  '--ts-var-button--tertiary--active-background': 'initial',
  '--ts-var-answer-chart-select-background': 'initial',
  '--ts-var-answer-chart-hover-background': 'initial',
  '--ts-var-chip-border-radius': 'initial',
  '--ts-var-chip-title-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-chip-box-shadow': 'initial',
  '--ts-var-chip-background': 'initial',
  '--ts-var-chip-color': 'var(--ts-var-root-color)',
  '--ts-var-chip--hover-background': 'initial',
  '--ts-var-chip--hover-color': 'var(--ts-var-root-color)',
  '--ts-var-chip--active-background': 'initial',
  '--ts-var-chip--active-color': 'initial',
  '--ts-var-axis-title-color': 'var(--ts-var-root-color)',
  '--ts-var-axis-title-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-axis-data-label-color': 'var(--ts-var-root-color)',
  '--ts-var-axis-data-label-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-menu-color': 'var(--ts-var-root-color)',
  '--ts-var-menu-background': 'initial',
  '--ts-var-menu-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-menu-text-transform': 'var(--ts-var-root-text-transform)',
  '--ts-var-menu--hover-background': 'initial',
  '--ts-var-menu-selected-text-color': 'initial',
  '--ts-var-dialog-body-background': 'initial',
  '--ts-var-dialog-body-color': 'var(--ts-var-root-color)',
  '--ts-var-dialog-header-background': 'initial',
  '--ts-var-dialog-header-color': 'var(--ts-var-root-color)',
  '--ts-var-dialog-footer-background': 'initial',
  '--ts-var-list-selected-background': 'initial',
  '--ts-var-list-hover-background': 'initial',
  '--ts-var-segment-control-hover-background': 'initial',
  '--ts-var-home-watchlist-selected-text-color': 'initial',
  '--ts-var-home-favorite-suggestion-card-text-color': 'initial',
  '--ts-var-home-favorite-suggestion-card-background': 'initial',
  '--ts-var-home-favorite-suggestion-card-icon-color': 'initial',
  '--ts-var-checkbox-error-border': 'initial',
  '--ts-var-checkbox-border-color': 'initial',
  '--ts-var-checkbox-hover-border': 'initial',
  '--ts-var-checkbox-active-color': 'initial',
  '--ts-var-checkbox-checked-color': 'initial',
  '--ts-var-checkbox-checked-disabled': 'initial',
  '--ts-var-checkbox-background-color': 'initial',
  '--ts-var-viz-title-color': 'var(--ts-var-root-color)',
  '--ts-var-viz-title-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-viz-title-text-transform': 'var(--ts-var-root-text-transform)',
  '--ts-var-viz-description-color': 'var(--ts-var-root-color)',
  '--ts-var-viz-description-font-family': 'var(--ts-var-root-font-family)',
  '--ts-var-viz-description-text-transform': 'var(--ts-var-root-text-transform)',
  '--ts-var-viz-border-radius': 'initial',
  '--ts-var-viz-box-shadow': 'initial',
  '--ts-var-viz-background': 'initial',
  '--ts-var-viz-legend-hover-background': 'initial',
  // Parameter chips - MISSING VARIABLES CAUSING THE ISSUE
  '--ts-var-parameter-chip-background': 'initial',
  '--ts-var-parameter-chip-text-color': 'var(--ts-var-root-color)',
  '--ts-var-parameter-chip-hover-background': 'initial',
  '--ts-var-parameter-chip-hover-text-color': 'var(--ts-var-root-color)',
  '--ts-var-parameter-chip-active-background': 'initial',
  '--ts-var-parameter-chip-active-text-color': 'var(--ts-var-root-color)',
  // Additional missing variables from official SDK interface
  '--ts-var-liveboard-layout-background': 'initial',
  '--ts-var-liveboard-header-background': 'initial',
  '--ts-var-liveboard-header-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-tile-border-color': 'initial',
  '--ts-var-liveboard-tile-background': 'initial',
  '--ts-var-liveboard-tile-border-radius': 'initial',
  '--ts-var-liveboard-tile-padding': 'initial',
  '--ts-var-liveboard-tile-table-header-background': 'initial',
  '--ts-var-liveboard-group-padding': 'initial',
  '--ts-var-liveboard-group-title-font-size': 'initial',
  '--ts-var-liveboard-group-title-font-weight': 'initial',
  '--ts-var-liveboard-group-tile-title-font-size': 'initial',
  '--ts-var-liveboard-group-tile-title-font-weight': 'initial',
  '--ts-var-liveboard-group-tile-padding': 'initial',
  '--ts-var-liveboard-answer-viz-padding': 'initial',
  '--ts-var-liveboard-group-background': 'initial',
  '--ts-var-liveboard-group-border-color': 'initial',
  '--ts-var-liveboard-notetitle-heading-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-notetitle-body-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-group-title-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-group-description-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-group-tile-title-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-group-tile-background': 'initial',
  '--ts-var-liveboard-chip-background': 'initial',
  '--ts-var-liveboard-chip-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-chip--hover-background': 'initial',
  '--ts-var-liveboard-chip--active-background': 'initial',
  '--ts-var-side-panel-width': 'initial',
  '--ts-var-liveboard-edit-bar-background': 'initial',
  '--ts-var-liveboard-dual-column-breakpoint': 'initial',
  '--ts-var-liveboard-single-column-breakpoint': 'initial',
  '--ts-var-liveboard-cross-filter-layout-background': 'initial',
  '--ts-var-liveboard-tab-active-border-color': 'initial',
  '--ts-var-liveboard-tab-hover-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-tile-title-fontsize': 'initial',
  '--ts-var-liveboard-tile-title-fontweight': 'initial',
  '--ts-var-liveboard-header-action-button-background': 'initial',
  '--ts-var-liveboard-header-action-button-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-header-action-button-hover-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-header-action-button-active-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-header-badge-background': 'initial',
  '--ts-var-liveboard-header-badge-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-header-badge-modified-background': 'initial',
  '--ts-var-liveboard-header-badge-modified-font-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-header-badge-hover-color': 'var(--ts-var-root-color)',
  '--ts-var-liveboard-header-badge-active-color': 'var(--ts-var-root-color)',
  '--ts-var-kpi-hero-color': 'var(--ts-var-root-color)',
  '--ts-var-kpi-comparison-color': 'var(--ts-var-root-color)',
  '--ts-var-kpi-analyze-text-color': 'var(--ts-var-root-color)',
  '--ts-var-chart-heatmap-legend-title-color': 'var(--ts-var-root-color)',
  '--ts-var-chart-heatmap-legend-label-color': 'var(--ts-var-root-color)',
  '--ts-var-chart-treemap-legend-title-color': 'var(--ts-var-root-color)',
  '--ts-var-chart-treemap-legend-label-color': 'var(--ts-var-root-color)',
  '--ts-var-kpi-positive-change-color': 'initial',
  '--ts-var-kpi-negative-change-color': 'initial',
  '--ts-var-change-analysis-insights-background': 'initial',
  '--ts-var-spotiq-analyze-forecasting-card-background': 'initial',
  '--ts-var-spotiq-analyze-outlier-card-background': 'initial',
  '--ts-var-spotiq-analyze-trend-card-background': 'initial',
  '--ts-var-spotiq-analyze-crosscorrelation-card-background': 'initial',
  '--ts-var-cca-modal-summary-header-background': 'initial',
};
